import { GameObjects } from 'phaser';
const { Container, Graphics } = GameObjects;

const TEXT_STYLE = {
	align: 'center',
	color: '#FFF',
	fontFamily: 'Arial',
	fontSize: 34 * 2,
};

export default class ButtonSolid extends Container {
	constructor(scene, x, y, text, color, width, height, style, highlight) {
		super(scene, x, y);


		if (!text) {
			text = 'Button';
		}

		if (!color) {
			color = 0x479ACE;
		}// or 0x479ACE or 0xC03500;

		if (!width) {
			width = 220;
		}

		if (!height) {
			height = 60;
		}

		if (!style) {
			style = TEXT_STYLE;
		}




		//background
		const graphics = new Graphics(scene);
		graphics.fillStyle(color);
		graphics.lineStyle(0, 0xFFFFFF, 1);
		graphics.fillRoundedRect(0, 0, width, height, 10);
		this.add(graphics);


		// Highlight border (optional)
		this.highlightGraphics = new Graphics(scene);
		this.highlightGraphics.lineStyle(2, 0xFFFF00, 1);
		this.highlightGraphics.strokeRoundedRect(-1, -1, width + 2, height + 2, 12);
		this.highlightGraphics.visible = highlight;
		this.add(this.highlightGraphics);

		this.textMessage = new GameObjects.Text(scene, 0, 0, text, style);
		this.textMessage.x = width / 2;
		this.textMessage.y = 10;
		this.textMessage.setScale(0.5);
		this.textMessage.setOrigin(0.5, 0);
		this.add(this.textMessage);

		// Set interactive with explicit hit area for the container
		this.setInteractive(new Phaser.Geom.Rectangle(0, 0, width, height), Phaser.Geom.Rectangle.Contains);


		if (!text) {
			this.visible = false;
		}
	}

	setText(text) {
		this.textMessage.setText(text);
		this.visible = !!text;
	}

	setHighlight(enabled) {
		if (this.highlightGraphics) {
			this.highlightGraphics.visible = enabled;
		}
	}
}
